module.exports = __webpack_public_path__ + "static/img-6-821ae907a7d22d84df63ce7a38ebaab2.jpeg";